import styled from 'styled-components';
import styleUtils from '../../../../styles/style.utils';
import themedColor, {
  ThemedColorReturn
} from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';

const Container = styled.div`
  margin-bottom: ${styleUtils.px(18)};
  width: 100%;
`;

const Checkbox = styled.div`
  display: flex;
`;
const CustomInput = styled.input`
  display: none;
`;

const StyledLabel = styled.div`
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('FORM')};
`;

const DecriptionLink = styled.a`
  &.ucf-link {
    color: ${themedColor('LINK')};
    font-size: ${themedFontSize('FORM')};
    font-weight: 600;
    text-decoration: underline;
    &:hover {
      color: ${themedColor('LINK')};
    }
  }
`;

interface CheckmarkProps {
  isActive: boolean;
}
const CheckmarkField = styled.div<CheckmarkProps>`
  background: ${themedColor('WHITE')};
  min-width: ${styleUtils.px(16)};
  width: ${styleUtils.px(16)};
  height: ${styleUtils.px(16)};
  border-radius: ${styleUtils.px(8)};
  border: ${styleUtils.px(1)} solid
    ${({ isActive }: CheckmarkProps): ThemedColorReturn =>
      isActive ? themedColor('TEXT_BLUE') : themedColor('TEXT_GREY')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${styleUtils.px(8)};
  cursor: pointer;
`;

const Checkmark = styled.div`
  background: ${({ isActive }: CheckmarkProps): ThemedColorReturn =>
    isActive ? themedColor('TEXT_BLUE') : themedColor('WHITE')};
  width: ${styleUtils.px(8)};
  height: ${styleUtils.px(8)};
  border-radius: ${styleUtils.px(4)};
`;

const FormCheckboxComponents = {
  Container,
  Checkbox,
  CustomInput,
  StyledLabel,
  CheckmarkField,
  Checkmark,
  DecriptionLink
};

export default FormCheckboxComponents;
